module.exports = __webpack_public_path__ + "7a3a62da6d776b84be816f1ee3a94bc2.jpg";